import {SimpleTableSortState} from 'ui-library/simple-table/useSimpleTableSortState';

export interface DataFrameSortInputVariable {
  columnSystemName: string;
  descending: boolean;
}

/**
 * Convert a `SimpleTableSortState` into the `DataFrameSortInput` GraphQL variable shape, for querying a
 * data frame table with server-side sorting.
 */
export default function toDataFrameSortInput(
  sortState: SimpleTableSortState
): DataFrameSortInputVariable | null {
  if (sortState == null) {
    return null;
  }
  return {
    columnSystemName: String(sortState.columnKey),
    descending: sortState.sortDirection === 'arrow-down',
  };
}
